// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__GNGhy","checkbox":"Checkbox_checkbox__cuau7","errors":"Checkbox_errors__D0gmT"};